var scope_0 = require('/home/circleci/project/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/2f1f9dbb1a6c0cffb3f27053c4f84c42.js').default;
var scope_1 = require('/home/circleci/project/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/33fd456718a71e9beeb0d569405d75f5.js').default;
var scope_2 = require('/home/circleci/project/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/9c726bf9eff4dcc985c1ff486471add1.js').default;
var scope_3 = require('/home/circleci/project/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/e92f8988d65cf25c087d226e6c0ef06f.js').default;export default
        Object.assign({}, scope_0,
scope_1,
scope_2,
scope_3 )
    